import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Checklist() {
  const items = ['Choose a company that comes out to inspect the bathroom and take proper measurements', 'Ask whether installers are experienced glass professionals', 'Finalize the quote after exact measurements and product selections', 'Confirm the company can custom cut glass and hardware to fit the opening', 'Ask about glass options, hardware finishes and installation details', 'Ask what caulk is used; a clean, mildew-resistant, non-shrinking caulk is preferred', 'Avoid companies that rely on excess caulk to hide gaps', 'Ask about the installation guarantee before work begins'];
  return <section className="py-20 bg-white" data-id="element-1490">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1491">
        <div className="max-w-3xl mx-auto text-center mb-16 anim-on-scroll" data-id="element-1492">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1493">
            What to Look for Before Hiring a Shower Door Installer
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1494">
            Use this scannable checklist to vet any shower glass installer
            before you commit.
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-100 mb-12" data-id="element-1495">
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-1496">
            {items.map((item, i) => <div key={i} className="flex items-start gap-4 scroll-fade-up" style={{
            animationDelay: `${i * 0.05}s`
          }} data-id="element-1497">
                <CheckCircle2 className="w-6 h-6 text-primary shrink-0 mt-0.5" data-id="element-1498" />
                <span className="text-gray-700 font-medium leading-relaxed" data-id="element-1499">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1500">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-navy hover:bg-navy-800 text-white font-semibold py-4 px-8 rounded-xl transition-colors" data-id="element-1501">
            Schedule an In-Home Measurement
          </a>
        </div>
      </div>
    </section>;
}